import { getRequest } from '../Helper/ApiClient';
import { BrandInterface } from '../../Interface/Brand';

const useTopBrands = (limit: number = 10) => {
  return getRequest<BrandInterface[]>(
      `/api/onlineshop/brands?sortBy=top&perPage=${limit}&context[]=image_public_url&context[]=banner_desktop_url`
    );
};

export default useTopBrands;
